// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3199":"761e6bd7","4654":"0c4e0ecb","8688":"c558803c"}[chunkId] + ".chunk.css";
};